import {PropsWithChildren} from "react";

export function None(props: PropsWithChildren<{
    onClick(): void;
}>) {
    return (
        <a style={{fontSize: "0.8rem", textDecoration: "underline", cursor: "pointer"}} onClick={() => props.onClick()}><i>
            {props.children}
        </i></a>
    )
}